import { ComponentProps, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Tooltip, TooltipContent, TooltipOrigin } from "../tooltip";
import { useBreakpoints } from "../../hooks/use-breakpoints";
import { EmptyText } from "../empty-text";
import { HelpIcon } from "../../icons";

type Placement = ComponentProps<typeof Tooltip>["placement"];

interface HelpTooltipProps {
  placement?: Placement;
  className?: string;
  children?: ReactNode;
}

/**
 * @deprecated use `TooltipDescription` instead
 *
 * `className` applies to the help icon
 */
export const HelpTooltip = ({
  placement,
  children,
  className,
}: HelpTooltipProps): JSX.Element => {
  const { sm } = useBreakpoints();

  if (!sm) return <></>;

  /**
   * inline-flex + the EmptyText ensures that the icon is vertically centered even when text wraps.
   */
  return (
    <Tooltip placement={placement}>
      <TooltipOrigin className="inline-flex items-center">
        <EmptyText />
        <HelpIcon className={twMerge("w-4 h-4 text-shale-400", className)} />
      </TooltipOrigin>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
};
